<template>
    <div>
        <div class="columns">
            <div
                class="column is-12 is-inline-flex is-justify-content-flex-end"
            >
                <div class="field mr-3">
                    <div class="control">
                        <label class="mr-2"
                            >Recarga en {{ reloadCountdown }} segundos</label
                        >
                        <button
                            class="button is-primary"
                            @click="reload"
                            :disabled="isLoading"
                        >
                            <Icon family="fal" name="fa-sync" />
                        </button>
                    </div>
                </div>
                <div class="select">
                    <select v-model="filters.skill" @change="refreshFilters">
                        <option value="">Seleccione un trámite</option>
                        <option value="None">Sin trámites</option>
                        <option
                            v-for="(item, index) in skills"
                            :key="`skill-${index}`"
                        >
                            {{ item.id }}
                        </option>
                    </select>
                </div>
                <div class="select ml-2">
                    <select v-model="filters.status" @change="refreshFilters">
                        <option value="">Seleccione un estado</option>
                        <option v-for="(k, v) in status" :key="k" :value="k">
                            {{ $t(`nomenclature.${v}`) }}
                        </option>
                    </select>
                </div>
                <div class="control ml-2">
                    <input
                        type="text"
                        class="input is-radiusless"
                        v-model="filters.search"
                    />
                </div>
                <button
                    class="button is-primary is-radiusless"
                    @click="refreshFilters"
                >
                    <Icon family="fal" name="fa-search" />
                </button>
                <div class="select ml-2">
                    <select v-model="filters.take" @change="refreshFilters">
                        <option>10</option>
                        <option>25</option>
                        <option>50</option>
                        <option>100</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column is-12 is-inline-flex" v-if="isLoading">
                <Loading />
            </div>
            <div class="column is-12 is-inline-flex" v-else>
                <table class="table is-striped is-hoverable is-fullwidth">
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Email</th>
                            <th>Estado</th>
                            <th>Trámites</th>
                            <th>Editar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(row, idx) in items">
                            <tr :key="idx">
                                <td>
                                    {{ row.name }}
                                </td>
                                <td>
                                    {{ row.email }}
                                </td>
                                <td>
                                    {{ parseStatus(row.status) }}
                                    <span
                                        v-if="
                                            row.status === 0 &&
                                            row.lastDisconnection
                                        "
                                    >
                                        <span class="tooltip">
                                            ({{
                                                $t(
                                                    `nomenclature.${row.lastDisconnection.disconnectionType}`
                                                )
                                            }})
                                            <span
                                                class="tooltiptext"
                                                v-if="
                                                    row.lastDisconnection.reason
                                                "
                                                >{{
                                                    row.lastDisconnection.reason
                                                }}</span
                                            >
                                        </span>
                                    </span>
                                </td>
                                <td>
                                    {{ parseSkills(row.skills) }}
                                </td>
                                <td>
                                    <button
                                        class="button is-primary"
                                        @click="openEdit(row)"
                                    >
                                        Editar
                                    </button>
                                </td>
                            </tr>
                        </template>
                        <tr v-if="totalPages === 0">
                            <td align="center" colspan="5">
                                No hay operadores...
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="columns">
            <div
                v-if="totalPages > 1"
                class="column is-12 is-inline-flex is-justify-content-flex-end"
            >
                <nav class="pagination" role="navigation">
                    <a
                        class="pagination-previous"
                        v-if="currentPage > 1"
                        v-on:click="prev()"
                        >Anterior</a
                    >
                    <a
                        class="pagination-previous"
                        v-if="currentPage < totalPages"
                        v-on:click="next()"
                        >Siguiente</a
                    >

                    <ul class="pagination-list">
                        <li v-if="currentPage > 2">
                            <a
                                class="pagination-link"
                                @click="goto(1)"
                                aria-label="Goto page 1"
                                >1</a
                            >
                        </li>

                        <li v-if="currentPage > 3">
                            <span class="pagination-ellipsis">&hellip;</span>
                        </li>
                        <li v-if="currentPage > 1">
                            <a
                                class="pagination-link"
                                v-on:click="goto(currentPage - 1)"
                                >{{ currentPage - 1 }}</a
                            >
                        </li>
                        <li>
                            <a
                                class="pagination-link is-current"
                                v-on:click="goto(currentPage)"
                                aria-current="page"
                                >{{ currentPage }}</a
                            >
                        </li>
                        <li v-if="totalPages > currentPage">
                            <a
                                class="pagination-link"
                                v-on:click="goto(currentPage + 1)"
                                >{{ currentPage + 1 }}</a
                            >
                        </li>
                        <li v-if="totalPages - currentPage > 2">
                            <span class="pagination-ellipsis">&hellip;</span>
                        </li>

                        <li v-if="totalPages - currentPage > 1">
                            <a
                                class="pagination-link"
                                v-on:click="goto(totalPages)"
                                >{{ this.totalPages }}</a
                            >
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <EditOperator
            :display="showEdit"
            :operator="selectedOperator"
            :skills="skills"
            @close="closeEdit"
        />
    </div>
</template>

<script>
import { RepositoryFactory } from "@/services/api";
import moment from "moment";

import EditOperator from "./EditOperator.vue";
import Loading from "@/components/Loading.vue";

export default {
    name: "operators-table",
    components: {
        Loading,
        EditOperator,
    },
    props: {
        signalRSocket: {
            type: Object,
            required: true,
        },
        skills: {
            type: Array,
            default: null,
        },
    },
    data() {
        return {
            isLoading: true,
            items: [],
            currentPage: 1,
            totalPages: 0,
            filters: {
                page: 1,
                take: 10,
                search: "",
                status: "",
                skill: "",
            },

            showEdit: false,
            selectedOperator: null,
            status: [],

            reloadCountdown: 60,
            reloadTimer: null,
        };
    },
    mounted() {
        this.getItems();
        this.getOperatorStatus();

        this.signalRSocket.on("OperatorJoined", this.operatorJoined);
        this.signalRSocket.on("OperatorLeaved", this.operatorLeaved);
    },
    beforeDestroy() {
        this.stopTimer();

        this.signalRSocket.off("OperatorJoined", this.operatorJoined);
        this.signalRSocket.off("OperatorLeaved", this.operatorLeaved);
    },
    methods: {
        restartTimer() {
            this.stopTimer();
            this.startTimer();
        },
        startTimer() {
            this.reloadTimer = setInterval(() => {
                this.reloadCountdown--;
                if (
                    !this.showEdit &&
                    !this.isLoading &&
                    this.reloadCountdown === 0
                ) {
                    this.reloadCountdown = 60;
                    this.getItems();
                } else if (this.reloadCountdown <= 0) {
                    this.reloadCountdown = 60;
                }
            }, 1000);
        },
        stopTimer() {
            this.reloadCountdown = 60;
            clearInterval(this.reloadTimer);
        },
        reload() {
            this.getItems();
        },
        openEdit(operator) {
            this.selectedOperator = operator;
            this.showEdit = true;

            this.restartTimer();
        },
        closeEdit(refresh) {
            if (refresh === true) {
                this.getItems();
                this.signalRSocket.invoke(
                    "OperatorUpdate",
                    this.selectedOperator.userId
                );
            }

            this.selectedOperator = null;
            this.showEdit = false;
        },
        operatorJoined() {
            this.getItems();
        },
        operatorLeaved() {
            this.getItems();
        },
        async getItems() {
            this.stopTimer();
            this.isLoading = true;
            try {
                var response =
                    await RepositoryFactory.operators.getPagedOnlineOperators(
                        this.filters
                    );
                this.items = response.data.items;
                this.totalPages = response.data.pages;
            } catch (error) {
                window.console.log(error);
            }
            this.isLoading = false;
            this.startTimer();
        },
        refreshFilters() {
            this.currentPage = 1;
            this.filters.page = this.currentPage;
            this.getItems();
        },
        goto(page) {
            this.currentPage = page;
            this.filters.page = this.currentPage;
            this.getItems();
        },
        prev() {
            this.currentPage = this.currentPage - 1;
            this.filters.page = this.currentPage;
            this.getItems();
        },
        next() {
            this.currentPage = this.currentPage + 1;
            this.filters.page = this.currentPage;
            this.getItems();
        },
        formatDate(date) {
            return moment(date).format("DD/MM/YYYY hh:mm A");
        },
        parseSkills(skills) {
            if (skills.length === 0) return "No tiene trámites";

            let response = skills.map((s) => s.id).join(", ");
            return response;
        },
        parseStatus(status) {
            switch (status) {
                case 0:
                    return "Desconectado";
                case 1:
                    return "Esperando";
                case 2:
                    return "En llamada";
            }
            return "-";
        },
        async getOperatorStatus() {
            try {
                let response =
                    await RepositoryFactory.nomenclature.getOperatorStatus();
                this.status = response.data;
            } catch (error) {
                window.console.log(error);
            }
        },
    },
};
</script>